//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// NOTE: Font based rendering for indicator rating images.  Ideally use FIBEmoji which is SVG Based.
export default {
  name: 'FibRating',
  props: {
    value: {
      // In order to allow null (from N/A ratings, we have to programmatically validate, rather than declare interfaces)
      validator: function validator(prop) {
        return typeof prop === 'string' || typeof prop === 'boolean' || typeof prop === 'number' || prop === null;
      },
      default: 0,
      required: true
    },
    size: {
      type: String,
      default: '3.5em',
      required: false
    },
    color: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: '5'
    },
    small: {
      type: Boolean,
      default: false
    },
    isSingle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    stylesTheme: function stylesTheme() {
      return {
        color: this.color || this.theme.primaryColor
      };
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value);
    }
  }
};